import React from 'react';
import Profile from './Profile';
import Experience from './Experience';
import Expertise from './Expertise';
import Services from './Services';
import Project from './Project';
import Contact from './Contact';

  
  const GetCard = (props)=>{
    switch(props.variant){
      case "profile":{
        return (
          <Profile/>
        );
      }
      case "experience":{
        return (
          <Experience/>
        );
      }
      case "expertise":{
        return (
          <Expertise showAll={props.showAll}/>
        );
      }
      case "services":{
        return (
          <Services showAll={props.showAll}/>
        );
      }
      case "project":{
        return (
          <Project showAll={props.showAll}/>
        );
      }
      case "contact":{
        return (
          <Contact/>
        );
      }
      default:{
        return;
      }
    }
  }



export default GetCard; 